import { DEFAULT_LANGUAGE } from '@core/constants/language';
import type { TranslateService } from '@ngx-translate/core';

/** Active UI language, with fallback when ngx-translate has not set one yet (v18+). */
export function getActiveLanguage(translateService: TranslateService): string {
  return translateService.currentLang() ?? DEFAULT_LANGUAGE;
}
